import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import cacheKeys from '@/data/api/cacheKeys';
import { getBuyerAddresses } from '@/data/api/request/buyersRequests';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

export function useGetBuyerAddresses(buyerId?: string) {
  const { showSnackError } = useSnackbarContext();

  const { data, error } = useQuery({
    queryFn: () => getBuyerAddresses(buyerId ?? ''),
    queryKey: [cacheKeys.buyer.addresses, buyerId],
    enabled: !!buyerId,
  });

  useEffect(() => {
    if (error)
      showSnackError('Error, no se pudo obtener los datos de contacto');
  }, [error]);

  return { data };
}
